import Vue from 'vue'
import Buefy from 'buefy'
import VueScrollTo from 'vue-scrollto';
import VeeValidate from 'vee-validate';

import App from './App.vue'
import router from './router'
import store from './store';
import buildLocale from './lib/buildLocale';
import './lib/fontawesome-all.min.exec.js';

// Load stylesheets
import './styles/index.scss';

import VueTypedJs from 'vue-typed-js';

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    Vue,
    dsn: "http://f55b179e97b5447e9a3d4f71c6103c2c@46.100.58.20:9000/9",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

// Load jQuery and it's global plugins
// window['jQuery'] = window['$'] = require('jquery');
// require('default-passive-events');
// require('slick-carousel');

Vue.use(Buefy, {
    defaultIconPack: 'fa'
});
Vue.use(VeeValidate);
Vue.use(VueScrollTo, {
    offset: -90
});

Vue.use(VueTypedJs);

const i18n = buildLocale(store);

// Start app
Vue.config.productionTip = false;
new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');
